import * as S from './Hero.style';
import * as T from './Hero.types';

export const Hero: React.FC<T.HeroPlatformaCollection> = ({ description, image, title }) => {
  return (
    <S.BannerPrincipal className="section">
      <S.Container>
        <S.Left>
          <h1>{title}</h1>
          <p className="subtitle">{description}</p>
        </S.Left>
        <S.Right>
          <img alt={title} src={image.url} width={1560} height={850} />
        </S.Right>
      </S.Container>
    </S.BannerPrincipal>
  );
};
